import type React from "react"

interface LoaderProps {
  size?: number
  color?: string
  duration?: number
}

const Loader: React.FC<LoaderProps> = ({ size = 40, color = "#6569f1", duration = 1.5 }) => {
  return (
    <div className="flex justify-center items-center">
      <div
        className="relative"
        style={{
          width: `${size}px`,
          height: `${size}px`,
        }}
      >
        <div
          className="absolute inset-0 rounded-full"
          style={{
            borderWidth: `${size * 0.1}px`,
            borderStyle: "solid",
            borderColor: `${color} transparent transparent ${color}`,
            animation: `roll ${duration}s linear infinite`,
          }}
        ></div>
        <div
          className="absolute inset-0 rounded-full"
          style={{
            borderWidth: `${size * 0.1}px`,
            borderStyle: "solid",
            borderColor: "transparent",
            transform: "rotate(135deg)",
            animation: `roll ${duration}s linear infinite reverse`,
          }}
        ></div>
      </div>
      <style>{`
        @keyframes roll {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  )
}

export default Loader